<div *ngIf="!order" class="container pt-5 pb-lg-5 pb-md-4 pb-2">

  <div *ngIf="cartItems?.length === 0" class="row">
    <div class="col">
      <h1 class="h2 mt-5 pt-lg-3 pb-md-1 pb-3">Cosul meu</h1>

      <div class="card border-0 text-center">
        <svg-icon src="assets/images/illustrations/empty-cart.svg" svgClass="w-50 h-50 my-3"></svg-icon>
        <div class="card-body">
          <h4 class="card-title">Cosul tau nu contine carduri cadou</h4>
          <a [routerLink]="['/carduri-cadou']" class="btn btn-primary w-100 w-sm-auto">Alege un card
            cadou</a>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="cartItems?.length > 0">
    <div class="row justify-content-center">
      <div class="col-12 col-xl-9">
        <h1 class="h2 mt-5 pt-lg-3 pb-md-1 pb-3">Cosul meu <span
            class="fs-base fw-normal text-muted">({{cartItems.length === 1 ? 'un card' : cartItems.length + '
            carduri'}})</span></h1>

        <!-- Order summary-->
        <div class="mt-4">

          <div *ngFor="let item of cartItems; index as i" class="d-sm-flex align-items-center border-top py-4">
            <a [routerLink]="['/carduri-cadou', item.voucherSlug]"
              class="d-inline-block flex-shrink-0 bg-white rounded-1 border border-2 p-1 p-sm-2 p-xl-3 mb-2 mb-sm-0"><img
                [src]="item.voucherImage" width="110" [alt]="item.voucherName"></a>
            <div class="w-100 pt-1 ps-sm-4">
              <div class="d-flex">
                <div class="me-3">
                  <h3 class="h5 mb-2"><a [routerLink]="['/carduri-cadou', item.voucherSlug]">{{item.voucherName}}</a>
                  </h3>
                  <div *ngIf="item.options?.length" class="d-sm-flex flex-wrap mb-2">
                    <div *ngFor="let option of item.options" class="text-body-secondary fs-sm me-3">
                      {{option.optionTypeName}}: <span class="text-dark fw-medium">{{option.name}}</span>
                    </div>
                  </div>
                </div>
                <div class="text-end ms-auto">
                  <div class="fs-5 mb-2">{{item.amount}} lei</div>
                </div>
              </div>
              <div class="count-input bg-gray rounded-3">
                <button (click)="editOrderItem(item.id, -1)" class="btn btn-icon fs-xl" type="button">-</button>
                <input [(ngModel)]="item.quantity" class="form-control" type="number">
                <button (click)="editOrderItem(item.id, +1)" class="btn btn-icon fs-xl" type="button">+</button>
              </div>
              <div class="nav justify-content-end mt-n5 mt-sm-n3"><a (click)="deleteOrderItem(item.id)"
                  class="nav-link fs-xl p-2" ngbTooltip="Sterge" role="button"><i class="ai-trash"></i></a></div>
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-between border-top fs-xl pt-4">Total:<span
              class="fs-3 fw-semibold text-dark ms-2">{{totalAmount}} lei</span></div>
        </div>

        <!-- Checkout form fields -->
        <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
          <div class="row g-4 mt-4 mt-md-5">
            <div class="col-12">
              <label class="form-label fs-base">Destinatia cardului cadou</label>
              <div class="btn-group w-100" role="group" aria-label="Basic radio toggle button group">
                <input formControlName="isOrderForMe" [value]="true" type="radio" class="btn-check"
                  id="isOrderForMeTrue">
                <label class="btn btn-outline-secondary" for="isOrderForMeTrue">Pentru mine</label>

                <input formControlName="isOrderForMe" [value]="false" type="radio" class="btn-check"
                  id="isOrderForMeFalse">
                <label class="btn btn-outline-secondary" for="isOrderForMeFalse">Pentru un prieten</label>
              </div>
            </div>
            <div *ngIf="hasOnlyGiftShareCards && templates?.length" class="col-12">

              <div class="d-flex align-items-center justify-content-between mb-3">
                <label class="form-label fs-base">Tematica</label>
                <div class="d-flex">
                  <button class="btn btn-prev btn-icon btn-sm btn-outline-primary rounded-circle me-3" type="button"
                    id="prev"><i class="ai-arrow-left"></i></button>
                  <button class="btn btn-next btn-icon btn-sm btn-outline-primary rounded-circle" type="button"
                    id="next"><i class="ai-arrow-right"></i></button>
                </div>
              </div>
              <swiper-container space-between="15" autoplay-delay="2500" autoplay-disable-on-interaction="false"
                [loop]="true" navigation-prev-el="#prev" navigation-next-el="#next" [breakpoints]="{
                '0': {
                  slidesPerView: 2
                },
                '576': {
                  slidesPerView: 3
                },
                '768': {
                  slidesPerView: 4
                },
                '992': {
                  slidesPerView: 3
                }
              }">
                <swiper-slide *ngFor="let template of templates">
                  <div class="card">
                    <img (click)="onSelectTemplateClick(template)" [src]="getImageTemplateFullUrl(template)"
                      [ngClass]="{'border border-3 border-primary': isTemplateSelected(template)}" class="card-img"
                      [alt]="template.name">
                  </div>
                </swiper-slide>
              </swiper-container>
            </div>
            <div *ngIf="!isOrderForMe" [@panelInOut] class="col-12">
              <label class="form-label fs-base" for="senderName">De la</label>
              <input formControlName="senderName" [ngClass]="{'is-invalid': vs.hasErrors(form, 'senderName')}"
                class="form-control form-control-lg" type="text" placeholder="Numele tau" id="senderName">
              <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'senderName')">{{vs.getError(form,
                'senderName')}}
              </div>
            </div>
            <div *ngIf="!isOrderForMe" [@panelInOut] class="col-12">
              <label class="form-label fs-base" for="recipientName">Pentru</label>
              <input formControlName="recipientName" [ngClass]="{'is-invalid': vs.hasErrors(form, 'recipientName')}"
                class="form-control form-control-lg" type="text" placeholder="Numele destinatarului" id="recipientName">
              <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'recipientName')">{{vs.getError(form,
                'recipientName')}}</div>
            </div>
            <div *ngIf="!isOrderForMe" [@panelInOut] class="col-12">
              <label class="form-label fs-base" for="recipientEmail">Email destinatar</label>
              <div class="position-relative"><i
                  class="ai-mail fs-lg position-absolute top-50 start-0 translate-middle-y ms-3"></i>
                <input formControlName="recipientEmail" [ngClass]="{'is-invalid': vs.hasErrors(form, 'recipientEmail')}"
                  class="form-control form-control-lg ps-5" type="email" placeholder="Email-ul destinatarului"
                  id="recipientEmail">
              </div>
              <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'recipientEmail')">{{vs.getError(form,
                'recipientEmail')}}</div>
            </div>
            <div *ngIf="!isOrderForMe" [@panelInOut] class="col-12">
              <label class="form-label fs-base" for="recipientMessage">Mesaj personalizat <span
                  class='text-muted'>(optional)</span></label>
              <textarea formControlName="recipientMessage"
                [ngClass]="{'is-invalid': vs.hasErrors(form, 'recipientMessage')}" class="form-control form-control-lg"
                rows="5" id="recipientMessage"></textarea>
              <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'recipientMessage')">{{vs.getError(form,
                'recipientMessage')}}</div>
            </div>

            <ng-container *ngIf="canScheduleNotification">
              <div class="col-12">
                <div class="form-check">
                  <input formControlName="hasNotificationDate"
                    [ngClass]="{'is-invalid': vs.hasErrors(form, 'hasNotificationDate')}" class="form-check-input"
                    type="checkbox" id="hasNotificationDate">
                  <label class="form-check-label text-dark fw-medium" for="hasNotificationDate">Trimitere
                    programata</label>
                  <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'hasNotificationDate')">{{vs.getError(form,
                    'hasNotificationDate')}}</div>
                </div>
              </div>
              <div *ngIf="hasNotificationDate" [@panelInOut] class="col-sm-6">
                <label class="form-label fs-base" for="notificationDate">Data trimiterii</label>
                <div class="position-relative"><i
                    class="ai-calendar fs-lg position-absolute top-50 start-0 translate-middle-y ms-3"></i>
                  <input formControlName="notificationDate" ngbDatepicker #datePicker="ngbDatepicker"
                    [minDate]="{ year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() }"
                    (click)="datePicker.toggle()" [ngClass]="{'is-invalid': vs.hasErrors(form, 'notificationDate')}"
                    class="form-control form-control-lg ps-5" type="text" id="notificationDate" readonly>
                </div>
                <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'notificationDate')">{{vs.getError(form,
                  'notificationDate')}}</div>
              </div>
              <div *ngIf="hasNotificationDate" [@panelInOut] class="col-sm-6">
                <label class="form-label fs-base" for="notificationTime">Ora trimiterii</label>
                <div class="position-relative"><i
                    class="ai-time fs-lg position-absolute top-50 start-0 translate-middle-y ms-3"></i>
                  <input [value]="form.value.notificationTime" [ngbPopover]="popContent" autoClose="outside"
                    [ngClass]="{'is-invalid': vs.hasErrors(form, 'notificationTime')}"
                    class="form-control form-control-lg ps-5" type="text" id="notificationTime" readonly>
                </div>
                <div class="invalid-feedback" *ngIf="vs.hasErrors(form, 'notificationTime')">{{vs.getError(form,
                  'notificationTime')}}</div>
                <div class="invalid-feedback" *ngIf="vs.hasFormError(form, 'futureDate')">Data introdusa trebuie sa fie
                  ulterioara datei curente.</div>
                <ng-template #popContent>
                  <ngb-timepicker formControlName="notificationTime">
                  </ngb-timepicker>
                </ng-template>
              </div>
            </ng-container>

            <div class="col-12">
              <div class="form-check">
                <input formControlName="hasAcceptedTerms"
                  [ngClass]="{'is-invalid': vs.hasErrors(form, 'hasAcceptedTerms')}" class="form-check-input"
                  type="checkbox" id="hasAcceptedTerms">
                <label class="form-check-label" for="hasAcceptedTerms"><span class="text-muted"> Am citit si sunt
                    de acord cu </span><a class="fw-medium" target="_blank" [routerLink]="['/termeni-si-conditii']">
                    Termenii si conditiile
                  </a>
                </label>
                <div *ngIf="vs.hasError(form, 'hasAcceptedTerms', 'required')" class="invalid-feedback">Termenii si
                  conditiile trebuie citite si acceptate.</div>
              </div>
            </div>
          </div>

          <div class="mb-5 mt-4">
            <div *ngIf="!hasMinimumOrder" class="alert alert-danger d-flex" role="alert">
              <i class="ai-circle-slash fs-xl me-2"></i>
              <div>Comanda minima este de {{minimumOrder}} lei.</div>
            </div>
            <div *ngIf="!hasRequiredFunds" class="alert alert-danger d-flex" role="alert">
              <i class="ai-circle-slash fs-xl me-2"></i>
              <div>Nu ai fonduri suficiente pentru a plasa comanda. <a (click)="onDepositClick()" class="alert-link"
                  role="button">Adauga fonduri</a></div>
            </div>
            <div *ngIf="error" class="alert alert-danger d-flex" role="alert">
              <i class="ai-circle-slash fs-xl me-2"></i>
              <div>{{error}}</div>
            </div>
            <button (click)="onSubmit()" class="btn btn-lg btn-primary w-100 w-sm-auto mb-3 mb-sm-0"
              type="button">Finalizare comanda</button>
            <a [routerLink]="['/carduri-cadou']"
              class="btn btn-lg btn-outline-primary w-100 w-sm-auto ms-sm-3">Adauga alte carduri</a>
          </div>
        </form>
      </div>

    </div>

  </ng-container>

</div>


<!-- Confirmation modal -->
<ng-template #confirmationModalTemplate let-modal>
  <div class="modal-header border-0">
    <h4 class="modal-title">Confirmare comanda</h4>
    <button (click)="modal?.dismiss()" class="btn-close" type="button" aria-label="Close"></button>
  </div>

  <div class="modal-body">

    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table text-nowrap">
            <thead>
              <tr>
                <th class="border-0 pb-3">
                  <span class="h5 mb-0">Card cadou</span>
                </th>
                <th class="border-0 pb-3 text-end">
                  <span class="h5 mb-0">Subtotal</span>
                </th>
              </tr>
            </thead>
            <tbody class="fs-sm">
              <tr *ngFor="let item of cartItems; even as even, index as index" [ngClass]="{'bg-gray' : even}">
                <th class="border-0 rounded-3 rounded-end-0 py-3 ps-4">
                  <span class="text-body fw-medium">{{item.voucherName}}</span>
                </th>
                <td class="border-0 rounded-3 rounded-start-0 py-3 text-end">
                  <span class="text-dark">{{item.total}} lei</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between fs-xl py-4">Total:<span
            class="fs-3 fw-semibold text-dark ms-2">{{totalAmount}} lei</span></div>
      </div>
    </div>

    <ng-container *ngIf="!isOrderForMe">
      <hr>
      <dl class="row mb-0 py-4">
        <dt class="col-sm-3">De la</dt>
        <dd class="col-sm-9">{{controls.senderName.value}}</dd>

        <dt class="col-sm-3">Pentru</dt>
        <dd class="col-sm-9">{{controls.recipientName.value}}</dd>

        <dt class="col-sm-3">Email</dt>
        <dd class="col-sm-9">{{controls.recipientEmail.value}}</dd>

        <ng-container *ngIf="canScheduleNotification && hasNotificationDate">
          <dt class="col-sm-3">Data trimitere</dt>
          <dd class="col-sm-9"><i class="ai-time me-2 ms-n1"></i>{{notificationDate | date:
            'dd/MM/yyyy HH:mm'}}</dd>
        </ng-container>

        <ng-container *ngIf="controls.recipientMessage.value">
          <dt class="col-sm-3">Mesaj</dt>
          <dd class="col-sm-9" [innerHTML]="recipientMessage"></dd>
        </ng-container>
      </dl>
    </ng-container>

    <ng-container *ngIf="hasOnlyGiftShareCards && selectedTemplate">
      <hr>
      <div class="row pt-4">
        <div class="col-12 text-center">
          <img [src]="getImageTemplateFullUrl(selectedTemplate)" class="rounded-5" alt="Tematica cardului cadou">
        </div>
      </div>
    </ng-container>

  </div>

  <div class="modal-footer border-0">
    <button (click)="modal?.close()" class="btn btn-secondary w-100 w-sm-auto mb-3 mb-sm-0"
      type="button">Anuleaza</button>
    <button (click)="onCheckoutConfirmSubmit()" class="btn btn-primary w-100 w-sm-auto ms-sm-3" type="submit"><i
        class="ai-cart me-2"></i> Plaseaza comanda</button>
  </div>
</ng-template>


<!-- Succeeded order -->
<div *ngIf="order" class="container pt-5 pb-lg-5 pb-md-4 pb-2">
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-9 col-lg-7">

      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <img src="assets/images/illustrations/successful-purchase.svg" class="w-50 mt-5 pt-lg-3 pb-md-1 pb-3"
            alt="Comanda plasata cu succes">
        </div>
        <div class="col-12 d-flex justify-content-center">
          <h1 class="h2 mt-5">Comanda plasata cu succes</h1>
        </div>
      </div>

      <dl class="row my-4">
        <dt class="col-6 col-sm-4">Numar comanda</dt>
        <dd class="col-6 col-sm-8 text-end text-sm-start"><i class="ai-hashtag me-2"></i><span
            class="fw-bold">{{order.orderNo}}</span></dd>
        <dt class="col-6 col-sm-4">Data comanda</dt>
        <dd class="col-6 col-sm-8 text-end text-sm-start"><i class="ai-time me-2"></i>{{order.submittedDate | date:
          'dd/MM/yyyy'}}</dd>
      </dl>

      <hr>

      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table text-nowrap">
              <thead>
                <tr>
                  <th class="border-0 pb-3">
                    <span class="h5 mb-0">Card cadou</span>
                  </th>
                  <th class="border-0 pb-3 d-none d-sm-table-cell">
                    <span class="h5 mb-0">Cantitate</span>
                  </th>
                  <th class="border-0 pb-3 d-none d-sm-table-cell">
                    <span class="h5 mb-0">Valoare</span>
                  </th>
                  <th class="border-0 pb-3 text-end">
                    <span class="h5 mb-0">Subtotal</span>
                  </th>
                </tr>
              </thead>
              <tbody class="fs-sm">
                <tr *ngFor="let item of order.orderItems; even as even, index as index" [ngClass]="{'bg-gray' : even}">
                  <th class="border-0 rounded-3 rounded-end-0 py-3">
                    <span class="text-body fw-medium">{{item.voucherName}}</span>
                  </th>
                  <th class="border-0 py-3 d-none d-sm-table-cell">
                    <span class="text-dark fw-semibold">{{item.quantity}}</span>
                  </th>
                  <th class="border-0 py-3 d-none d-sm-table-cell">
                    <span class="text-dark fw-semibold">{{item.amount}} lei</span>
                  </th>
                  <td class="border-0 rounded-3 rounded-start-0 py-3 text-end">
                    <span class="text-dark fw-semibold">{{item.total}} lei</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between fs-xl py-4">Total:<span
              class="fs-3 fw-semibold text-dark ms-2">{{totalAmount}} lei</span></div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="alert alert-info" role="alert">
            <h4 class="pt-2 alert-heading"><i class="ai-circle-info fs-xl pe-1 me-2"></i>Comanda in procesare</h4>
            <hr class="text-info opacity-25 mb-3">
            <p>Comanda va fi procesata in cel mai scurt timp.</p>
            <p>Cardurile cadou la parteneri sunt generate si livrate pe email în
              maximum 2 zile lucratoare.</p>
            <p class="mb-2">Cardurile cadou GiftShare sunt generate si livrate pe email imediat
              dupa confirmarea platii, cat ai zice #CadoulPerfect. 🙂
            </p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-center mt-4">
          <a [routerLink]="['/user/dashboard']" class="btn btn-secondary w-100 w-sm-auto mb-3 mb-sm-0">Inapoi la
            dashboard</a>
          <a [routerLink]="['/user/comenzi']" class="btn btn-primary w-100 w-sm-auto ms-sm-3">Status comanda</a>
        </div>
      </div>
    </div>
  </div>
</div>
